import { useEffect } from 'react'

export const USE_DEBOUNCED_CALLBACK_DEFAULT_TIMEOUT = 100

export const useDebouncedCallback = (
  func: (...args: any[]) => any,
  time = USE_DEBOUNCED_CALLBACK_DEFAULT_TIMEOUT,
  args?: any
) => {
  useEffect(() => {
    const timeout = setTimeout(() => {
      func(args)
    }, time)

    return () => {
      clearTimeout(timeout)
    }
  }, [func, args, time])
}
